<template>
    <transition name="fade">
        <div class="bg-black/70 fixed inset-0 p-4 flex items-center z-100" v-if="isVisible">
            <div class="bg-white dark:bg-slate-800 w-full rounded-xl shadow-xl max-w-sm mx-auto p-4">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
<script>
export default {
    data: () => ({
        isVisible: false,
    }),
    methods: {
        open() {
            this.isVisible = true
        },

        close() {
            this.isVisible = false
        },
    },
}
</script>
